export var registerVehicleInitialState = {
    firstName: '',
    lastName: '',
    userAlias: '',
    vehicleType: '',
    make: '',
    model: '',
    year: '',
    color: '',
    licensePlate: '',
    state: '',
    registrationType: '',
    parkingLocation: '',
    permitNumber: '',
    registrationDate: '',
    expireInDays: '0',
    isParkingPolicyChecked: false,
    isCarpoolChecked: false,
    carpoolStatus: false,
    isNewLicenseChecked: false,
    ownerFirstName: '',
    ownerLastName: '',
    chaufferName: '',
    chaufferContactNumber: '',
    chaufferDrivingLicense: '',
    fuelType: '',
    contactNumber: '',
    disability: false,
    parkingStickerCollected: false,
};
export var resetVehicleDetailState = {
    vehicleType: '',
    make: '',
    model: '',
    year: '',
    color: '',
    licensePlate: '',
    state: '',
    registrationType: '',
    parkingLocation: '',
    permitNumber: '',
    registrationDate: '',
    expireInDays: '0',
    userAlias: '',
    firstName: '',
    lastName: '',
    isParkingPolicyChecked: false,
    isCarpoolChecked: false,
    carpoolStatus: false,
    isNewLicenseChecked: false,
    ownerFirstName: '',
    ownerLastName: '',
    chaufferName: '',
    chaufferContactNumber: '',
    chaufferDrivingLicense: '',
    fuelType: '',
    contactNumber: '',
    disability: false,
    parkingStickerCollected: false,
};
export var userInitialState = {
    firstName: '',
    lastName: '',
    userAlias: '',
};
export var vehicleDetailInitialErrorState = {
    isFirstNameError: false,
    isLastNameError: false,
    isVehicleTypeError: false,
    isMakeError: false,
    isModelError: false,
    isColorError: false,
    isYearError: false,
    isLicensePlateError: false,
    isStateError: false,
    isRegistrationTypeError: false,
    isParkingLocationError: false,
    isPolicyCheckedError: false,
    isFormSubmit: false,
    closeModal: false,
    isChaufferContactNumberError: false,
    isChaufferDrivingLicenseError: false,
    isChaufferNameError: false,
    isCountryError: false,
    isContactNumberError: false,
    isFuelTypeError: false,
    isExpiryDateError: false,
};
export var formInitialState = {
    isFormEdit: false,
    isAnyFieldEdited: false,
};
export var infoBadgeStateInitialState = {
    response: false,
    message: '',
    closeStatusModal: false,
    responseStatus: '',
};
export var registeredVehicleDataItem = [
    {
        color: '',
        expireInDays: '0',
        firstName: '',
        lastName: '',
        licensePlate: '',
        make: '',
        model: '',
        parkingLocation: '',
        permitNumber: '',
        registrationDate: '',
        registrationId: '',
        registrationType: '',
        state: '',
        userAlias: '',
        vehicleType: '',
        year: '',
        isParkingPolicyChecked: false,
        carpoolStatus: false,
        isCarpoolChecked: false,
        isNewLicenseChecked: false,
        ownerFirstName: '',
        ownerLastName: '',
        chaufferName: '',
        chaufferContactNumber: '',
        chaufferDrivingLicense: '',
        fuelType: '',
        contactNumber: '',
        disability: false,
        parkingStickerCollected: false,
    },
];
export var emailInitialState = {
    to: '',
    subject: '',
    emailBody: '',
    cc: '',
    mailType: '',
};
export var chaufferIntialState = {
    chaufferName: '',
    chaufferContactNumber: '',
    chaufferDrivingLicense: '',
};
